export default __webpack_public_path__ + "static/media/_dkg_magen_rgb.93d2b2b6.svg";